export default "__VITE_ASSET__e2b10aa6__"